import { INVENTORY_PREORDERS } from '../actionTypes';

const initialState = {
  content: [],
  supportTypes: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INVENTORY_PREORDERS.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case INVENTORY_PREORDERS.PREORDERS_FILTER_SUCCESS:
      return {
        ...state,
        supportTypes: action.payload,
      };
    default:
      return state;
  }
};
